// ZETA SEARCH クライアント。設定は window.ZETA_CONFIG。
(function () {
  'use strict';

  const DEFAULTS = {
    enabled: false,
    endpoint: 'https://joix.search.zetacx.net/api/ps/item',
    productHost: '',
    limit: 10,
    stockOnly: true,
    pageLimit: 24,
    facets: 'brand,category,size,fit,color,pattern,style,collection,price,type,item_stock,material',
  };

  const FILTER_FIELDS = [
    { key: 'brand', label: 'BRAND', primary: true },
    { key: 'category', label: 'CATEGORY', primary: true },
    { key: 'size', label: 'SIZE' },
    { key: 'fit', label: 'FIT' },
    { key: 'color', label: 'COLOR' },
    { key: 'pattern', label: 'PATTERN' },
    { key: 'style', label: 'STYLE' },
    { key: 'collection', label: 'COLLECTION' },
    { key: 'price', label: 'PRICE' },
    { key: 'type', label: 'TYPE' },
    { key: 'material', label: 'MATERIAL' },
  ];

  const SORT_OPTIONS = [
    { value: 'score', label: 'RELEVANCE' },
    { value: 'popularity', label: 'POPULARITY' },
  ];

  function getConfig() {
    return Object.assign({}, DEFAULTS, window.ZETA_CONFIG || {});
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatPrice(value) {
    const num = Number(value);
    if (!Number.isFinite(num) || num <= 0) return '';
    return `¥${num.toLocaleString('ja-JP')}`;
  }

  function normalizeHost(host) {
    return String(host || '').replace(/\/$/, '');
  }

  function resolveImageUrl(item) {
    return (item && (item.item_img_large_url || item.item_img_url)) || '';
  }

  function getProductPath(item) {
    if (item && item.desc_url) return item.desc_url;
    return '#';
  }

  function resolveProductUrl(item) {
    const productHost = normalizeHost(getConfig().productHost);
    const path = getProductPath(item);
    if (/^https?:\/\//.test(path)) return path;
    if (productHost) return productHost + path;
    return path;
  }

  function uniqueColorItems(rawItems, limit) {
    const seen = new Set();
    const items = [];
    for (const item of rawItems) {
      const key = item.item_id_color_cd || item.sku_cd;
      if (seen.has(key)) continue;
      seen.add(key);
      items.push(item);
      if (items.length >= limit) break;
    }
    return items;
  }

  function appendFilters(params, filters) {
    Object.keys(filters || {}).forEach((key) => {
      const values = filters[key] || [];
      values.forEach((value) => {
        if (value) params.append(key, value);
      });
    });
  }

  async function searchItems(term, options, signal) {
    const config = getConfig();
    const opts = options || {};
    const fetchLimit = opts.limit || Math.min((config.limit || 10) * 3, 60);
    const params = new URLSearchParams({
      q: term,
      l: String(fetchLimit),
      o: String(opts.offset || 0),
      c: config.facets,
      f: '0',
      s: opts.sort || 'score',
      stock: config.stockOnly ? '1' : '0',
      color_info: '0',
    });
    appendFilters(params, opts.filters);

    const response = await fetch(`${config.endpoint}?${params.toString()}`, {
      headers: { accept: 'application/json' },
      signal,
    });
    if (!response.ok) {
      throw new Error(`ZETA search failed: ${response.status}`);
    }
    return response.json();
  }

  function buildPredictiveItemMarkup(item, index) {
    const url = escapeHtml(resolveProductUrl(item));
    const image = resolveImageUrl(item);
    const name = escapeHtml(item.item_nm);
    const color = escapeHtml(item.color_nm || '');
    const price = formatPrice(item.sale_price || item.fixed_price);
    const imageMarkup = image
      ? `<div class="zeta-predictive__image">
          <img src="${escapeHtml(image)}" alt="${name}" width="96" height="128" loading="lazy">
        </div>`
      : '<div class="zeta-predictive__image zeta-predictive__image--empty"></div>';
    const colorMarkup = color ? `<span class="zeta-predictive__color">${color}</span>` : '';
    const priceMarkup = price ? `<span class="zeta-predictive__price">${price}</span>` : '';

    return `<li
        id="predictive-search-option-product-${index + 1}"
        class="predictive-search__list-item zeta-predictive__item"
        role="option"
        aria-selected="false"
      >
        <a href="${url}" class="predictive-search__item zeta-predictive__link link link--text" tabindex="-1">
          <span class="zeta-predictive__meta">
            <span class="zeta-predictive__brand">Paul Smith</span>
            <span class="zeta-predictive__name">${name}</span>
            <span class="zeta-predictive__detail">${colorMarkup}${priceMarkup}</span>
          </span>
          ${imageMarkup}
        </a>
      </li>`;
  }

  function buildDropdownMarkup(data, term) {
    const config = getConfig();
    const result = (data && data.result) || {};
    const rawItems = Array.isArray(result.items) ? result.items : [];
    const items = uniqueColorItems(rawItems, config.limit || 10);
    const total = (result.attribute && result.attribute.total) || items.length;
    const safeTerm = escapeHtml(term);
    const liveRegion = `<span class="visually-hidden" data-predictive-search-live-region-count-value>${total}</span>`;
    const searchUrl = (window.routes && window.routes.search_url) || '/search';
    const seeAllHref = `${searchUrl}?q=${encodeURIComponent(term)}`;

    if (items.length === 0) {
      return `${liveRegion}
        <div id="predictive-search-results" class="zeta-predictive" role="listbox">
          <div class="zeta-predictive__stories">0 PAGE & STORY</div>
          <p class="zeta-predictive__empty" role="status">0 RESULTS, PLEASE TRY ANOTHER SEARCH TERM.</p>
        </div>`;
    }

    return `${liveRegion}
      <div id="predictive-search-results" class="zeta-predictive" role="listbox">
        <div class="zeta-predictive__stories">0 PAGE & STORY</div>
        <div id="predictive-search-results-groups-wrapper" class="predictive-search__results-groups-wrapper zeta-predictive__wrapper">
          <div class="predictive-search__result-group zeta-predictive__group" role="group">
            <div class="zeta-predictive__heading" id="predictive-search-products">
              <span>${total} PRODUCTS</span>
              <a href="${escapeHtml(seeAllHref)}" class="zeta-predictive__view-all" tabindex="-1">VIEW ALL</a>
            </div>
            <ul
              id="predictive-search-results-products-list"
              class="predictive-search__results-list zeta-predictive__list list-unstyled"
              role="group"
              aria-labelledby="predictive-search-products"
            >
              ${items.map(buildPredictiveItemMarkup).join('')}
            </ul>
          </div>
        </div>
      </div>`;
  }

  function flattenFacetEntries(entries, depth) {
    if (!Array.isArray(entries)) return [];
    const level = depth || 0;
    const flattened = [];
    entries.forEach((entry) => {
      const value = entry.value || entry.url_name || entry.name;
      if (value) {
        flattened.push({
          name: entry.name,
          value,
          count: entry.count,
          level,
        });
      }
      flattened.push(...flattenFacetEntries(entry.child, level + 1));
    });
    return flattened;
  }

  function readPageState() {
    const params = new URLSearchParams(window.location.search);
    const filters = {};
    FILTER_FIELDS.forEach((field) => {
      const values = params.getAll(`z_${field.key}`);
      if (values.length) filters[field.key] = values;
    });
    return {
      term: params.get('q') || '',
      page: Math.max(Number(params.get('page') || 1), 1),
      sort: params.get('z_sort') || 'score',
      filters,
    };
  }

  function buildPageUrl(nextState) {
    const params = new URLSearchParams(window.location.search);
    params.set('q', nextState.term || '');
    params.delete('options[prefix]');
    params.delete('page');
    params.delete('z_sort');
    FILTER_FIELDS.forEach((field) => params.delete(`z_${field.key}`));

    if (nextState.page && nextState.page > 1) params.set('page', String(nextState.page));
    if (nextState.sort && nextState.sort !== 'score') params.set('z_sort', nextState.sort);
    Object.keys(nextState.filters || {}).forEach((key) => {
      nextState.filters[key].forEach((value) => params.append(`z_${key}`, value));
    });
    return `${window.location.pathname}?${params.toString()}`;
  }

  function isActiveFilter(filters, key, value) {
    return Boolean(filters[key] && filters[key].includes(value));
  }

  function toggleFilter(state, key, value) {
    const filters = Object.assign({}, state.filters);
    const values = filters[key] ? filters[key].slice() : [];
    const index = values.indexOf(value);
    if (index >= 0) {
      values.splice(index, 1);
    } else {
      values.push(value);
    }
    if (values.length) {
      filters[key] = values;
    } else {
      delete filters[key];
    }
    return Object.assign({}, state, { filters, page: 1 });
  }

  function buildFacetGroup(result, field, filters, open) {
    const facetRoot = result.facet || {};
    const entries = flattenFacetEntries(result[field.key] || facetRoot[field.key]);
    if (!entries.length) return '';
    const items = entries
      .slice(0, 24)
      .map((entry) => {
        const active = isActiveFilter(filters, field.key, entry.value);
        const levelClass = entry.level ? ` zeta-search__facet-option--level-${entry.level}` : '';
        return `<button
            type="button"
            class="zeta-search__facet-option${levelClass}${active ? ' is-active' : ''}"
            data-zeta-filter-key="${escapeHtml(field.key)}"
            data-zeta-filter-value="${escapeHtml(entry.value)}"
            aria-pressed="${active ? 'true' : 'false'}"
          >
            <span>${escapeHtml(entry.name)}</span>
            <span>${escapeHtml(entry.count || 0)}</span>
          </button>`;
      })
      .join('');

    return `<details class="zeta-search__facet" ${open ? 'open' : ''}>
      <summary>${escapeHtml(field.label)}</summary>
      <div class="zeta-search__facet-options">${items}</div>
    </details>`;
  }

  function buildFacetMarkup(result, state) {
    const primary = FILTER_FIELDS.filter((field) => field.primary)
      .map((field) => buildFacetGroup(result, field, state.filters, false))
      .join('');
    const more = FILTER_FIELDS.filter((field) => !field.primary)
      .map((field) => buildFacetGroup(result, field, state.filters, false))
      .join('');
    const moreMarkup = more
      ? `<details class="zeta-search__facet zeta-search__facet--more">
          <summary>MORE FILTERS +</summary>
          <div class="zeta-search__more-groups">${more}</div>
        </details>`
      : '';
    return `${primary}${moreMarkup}`;
  }

  function buildSortMarkup(state) {
    const options = SORT_OPTIONS.map((option) => {
      const selected = option.value === state.sort ? ' selected' : '';
      return `<option value="${escapeHtml(option.value)}"${selected}>${escapeHtml(option.label)}</option>`;
    }).join('');
    return `<label class="zeta-search__sort">
      <span>SORT BY</span>
      <select data-zeta-sort>${options}</select>
    </label>`;
  }

  function buildProductCard(item) {
    const url = escapeHtml(resolveProductUrl(item));
    const image = resolveImageUrl(item);
    const name = escapeHtml(item.item_nm);
    const brand = escapeHtml(item.brand_nm || 'Paul Smith');
    const color = escapeHtml(item.color_nm || '');
    const price = formatPrice(item.sale_price || item.fixed_price);
    const imageMarkup = image
      ? `<img src="${escapeHtml(image)}" alt="${name}" width="360" height="480" loading="lazy">`
      : '<span class="zeta-search__image-empty">Paul Smith</span>';
    const colorMarkup = color ? `<span>${color}</span>` : '';
    const priceMarkup = price ? `<span>${price}</span>` : '';

    return `<li class="zeta-search__product">
      <a href="${url}" class="zeta-search__product-link">
        <span class="zeta-search__image">${imageMarkup}</span>
        <span class="zeta-search__brand">${brand}</span>
        <span class="zeta-search__name">${name}</span>
        <span class="zeta-search__details">${colorMarkup}${priceMarkup}</span>
      </a>
    </li>`;
  }

  function buildPaginationMarkup(state, total, perPage) {
    const pages = Math.ceil(total / perPage);
    if (pages <= 1) return '';
    const prev =
      state.page > 1
        ? `<button type="button" data-zeta-page="${state.page - 1}">PREVIOUS</button>`
        : '<button type="button" disabled>PREVIOUS</button>';
    const next =
      state.page < pages
        ? `<button type="button" data-zeta-page="${state.page + 1}">NEXT</button>`
        : '<button type="button" disabled>NEXT</button>';
    return `<nav class="zeta-search__pagination" aria-label="Pagination">
      ${prev}
      <span>${state.page} / ${pages}</span>
      ${next}
    </nav>`;
  }

  function buildSearchPageMarkup(data, state, perPage) {
    const result = (data && data.result) || {};
    const attribute = result.attribute || {};
    const rawItems = Array.isArray(result.items) ? result.items : [];
    const items = uniqueColorItems(rawItems, perPage);
    const total = Number(attribute.total || items.length);
    const controls = buildFacetMarkup(result, state);
    const products = items.length
      ? `<ul class="zeta-search__grid" role="list">${items.map(buildProductCard).join('')}</ul>`
      : `<p class="zeta-search__empty">0 RESULTS, PLEASE TRY ANOTHER SEARCH TERM.</p>`;

    return `<div class="zeta-search" data-zeta-search>
      <div class="zeta-search__toolbar">
        <button class="zeta-search__view" type="button" aria-label="Grid view">▦</button>
        <span class="zeta-search__count">${total} ITEMS</span>
        <div class="zeta-search__filters">${controls}</div>
        ${buildSortMarkup(state)}
      </div>
      ${products}
      ${buildPaginationMarkup(state, total, perPage)}
    </div>`;
  }

  function setNativeSearchHidden(hidden) {
    document.body.classList.toggle('zeta-search-active', hidden);
    document.querySelectorAll('#main-search-filters, .facets-vertical-sort').forEach((element) => {
      element.hidden = hidden;
    });
  }

  async function renderSearchPage(nextState, updateUrl) {
    if (!nextState.term) return;
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;

    const config = getConfig();
    const perPage = config.pageLimit || 24;
    const offset = (nextState.page - 1) * perPage;
    setNativeSearchHidden(true);
    container.innerHTML = '<div class="zeta-search zeta-search--loading">LOADING</div>';

    try {
      const data = await searchItems(nextState.term, {
        limit: perPage * 2,
        offset,
        sort: nextState.sort,
        filters: nextState.filters,
      });
      container.innerHTML = buildSearchPageMarkup(data, nextState, perPage);
      if (updateUrl) window.history.pushState({ zetaSearch: true }, '', buildPageUrl(nextState));
    } catch (error) {
      setNativeSearchHidden(false);
      console.error('[ZETA] search page error:', error);
    }
  }

  function bindSearchPage() {
    if (!getConfig().enabled) return;
    if (window.location.pathname !== ((window.routes && window.routes.search_url) || '/search')) return;
    const initialState = readPageState();
    if (!initialState.term) return;

    document.addEventListener('click', (event) => {
      const filterButton = event.target.closest('[data-zeta-filter-key]');
      if (filterButton) {
        event.preventDefault();
        const state = readPageState();
        const nextState = toggleFilter(state, filterButton.dataset.zetaFilterKey, filterButton.dataset.zetaFilterValue);
        renderSearchPage(nextState, true);
        return;
      }

      const pageButton = event.target.closest('[data-zeta-page]');
      if (pageButton) {
        event.preventDefault();
        const state = readPageState();
        renderSearchPage(Object.assign({}, state, { page: Number(pageButton.dataset.zetaPage) }), true);
      }
    });

    document.addEventListener('change', (event) => {
      if (!event.target.matches('[data-zeta-sort]')) return;
      const state = readPageState();
      renderSearchPage(Object.assign({}, state, { sort: event.target.value, page: 1 }), true);
    });

    window.addEventListener('popstate', () => {
      renderSearchPage(readPageState(), false);
    });

    renderSearchPage(initialState, false);
  }

  document.addEventListener('DOMContentLoaded', bindSearchPage);

  window.Zeta = {
    getConfig,
    searchItems,
    buildDropdownMarkup,
    bindSearchPage,
    resolveImageUrl,
    resolveProductUrl,
  };
})();
